import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { MdFavorite, MdAutoAwesome } from "react-icons/md";
import "./CheckInLanding.css";

const items = [
    "TRUSTED BY 24,000+ PEOPLE",
    "4.9 ★ APP STORE",
    "FEATURED IN WIRED",
    "SOC 2 COMPLIANT",
];

export default function AboutSection() {
    return (
        <section className="about-section" id="About Us">
            <Container>
                <Row className="align-items-center g-5">
                    {/* Left Side */}
                    <Col lg={6}>
                        <p className="section-tag">— ABOUT US</p>

                        <h2 className="about-title">
                            Built on <span>40 years</span> of craft —
                            <br />
                            guided by care.
                        </h2>

                        <p className="about-text">
                            Keep in Touch leverages over four decades of software development
                            experience to bring quiet, reliable peace of mind to the people
                            who need it most.
                        </p>
                    </Col>

                    {/* Right Side */}
                    <Col lg={6}>
                        <Row className="g-4">
                            {/* Mission */}
                            <Col md={6} className="mb-lg-0 mb-3">
                                <Card className="info-card h-100">
                                    <Card.Body>
                                        <IconBadge>
                                            <MdFavorite size={18} color="#fff" />
                                        </IconBadge>

                                        <h4>Our mission</h4>

                                        <p>
                                            To make personal safety effortless — so vulnerable
                                            communities can hold on to independence without trading
                                            peace of mind.
                                        </p>
                                    </Card.Body>
                                </Card>
                            </Col>
                            {/* Vision */}
                            <Col md={6}>
                                <Card className="info-card dark-card h-100">
                                    <Card.Body>
                                        <IconBadge>
                                            <MdAutoAwesome size={18} />
                                        </IconBadge>

                                        <h4>Our vision</h4>

                                        <p>
                                            A world where checking in is as natural as locking the
                                            door — quiet, automatic, and always there in the
                                            background.
                                        </p>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                        {/* Trusted Bar */}

                    </Col>
                    <Col lg={12}>
                        <div className="trusted-wrapper mt-4">
                            {items.map((item, index) => (
                                <React.Fragment key={index}>
                                    <span className="trusted-item">{item}</span>

                                    {index !== items.length - 1 && (
                                        <span className="trusted-divider">/</span>
                                    )}
                                </React.Fragment>
                            ))}
                        </div>

                    </Col>
                </Row>
            </Container>
        </section>
    );
}

function IconBadge({children}) {
    return <div className="icon-badge">{children}</div>;
}